<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/"> {{language[1]['Home']}}  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/user/index">{{language[7]['Manage Users']}}   </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>  {{language[79]['Create User']}}</h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div style="padding-bottom: 300px;" class="container-fluid">
                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">


                    <form @submit.prevent="SaveUrl()" >

<b-modal :id="infoModal3.id" 
  
  size="sm" 
  > 
  <template #modal-title>
                  <h5>New User Type</h5>
                </template>
  <div>
    <input  v-model="all_data.newroles"   style="font-size: small;" class="form-control" >
  </div>
  <template #modal-footer>
                  <button style="font-size: small;"  @click="saveRoleType" class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">Save</button>
                  
                </template>
 </b-modal>

 


<div class="row">
 
  
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">{{language[60]['Username']}} </label>
            <input  v-model="all_data.username"  style="font-size: small;" class="form-control">
    </div>
  </div>
 
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">{{language[63]['New Password']}}</label>
            <input  v-model="all_data.password"  type="password"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;"> {{language[64]['Repeat New Password']}}</label>
            <input  v-model="all_data.password2" type="password"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;"> {{language[76]['Email']}}</label>
            <input  v-model="all_data.email"   style="font-size: small;" class="form-control" >
    </div>
  </div>
  
 

  
</div>


<div class="row">
  <div  v-show="selectusertype" class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">User Type </label>
            <v-select @input="imageLoad1()"  v-model="all_data.rolestype" :options="roles"  label="name" ></v-select>
    </div>
  </div>
</div>






















   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">{{language[52]['Create']}}</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
           
            </div>
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import httpClient from '@/axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
            this.loadCat()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            language:JSON.parse(authService.isLanguage()),
            id:this.$route.query.id,
        total:0,
        selectedOption: null, // Store the selected option
        selectusertype:true,
        newusertype:false,

        brands:[],
        suppliers:[],
        roles:[],
        Locations:[],
        all_data:{
          'newuser':false,
        },
       
        infoModal3: {
          id: 'info-modal3',
          title: '',
          content: [],
        },
      
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {

          async imageLoad1(){

if(this.all_data.rolestype.id == 0){
  this.infoModal3.content = 1;
  this.$root.$emit('bv::show::modal', this.infoModal3.id);
}


},    

    saveRoleType() {
      
      this.$bvModal.hide(this.infoModal3.id); 
     
    },
    
        
     contrcor(){

    console.log(this.all_data.newuser);
      if(this.all_data.newuser==true){
        this.newusertype = true;
        this.selectusertype = false;
      }else if (this.all_data.newuser==false) {
        this.newusertype = false;
        this.selectusertype = true;
      
      }
      


    },


    async loadCat() {
    
    console.log(this.issue);
   
    try {
      const { data} = await  httpClient.get('/web/api/user/loadroalper',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.roles = data.roles;
       
      
    } catch (error) {
      console.log(error.response);
    }
  },

    async SaveUrl() {
       
      if(this.all_data.password2 != this.all_data.password){
        alert('please enter the correct password');
        return ;
      }
   
    console.log("amilaaaa");
       try {
         const { data} = await  httpClient.post('/web/api/user/createuser',{id:this.id,all_data:this.all_data},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/user/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },
       

     

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    